import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";
import { IPuntoCampionamento } from "../punti-campionamento/punti-campionamento.model";
import { ITableColumn } from "src/app/core/models/table.model";
import { IMapPuntiCoordinate } from "./models/dashboard-card.model";

export const GPS_ENDPOINT = 'punti-campionamento-dash';
export const GPS_ENDPOINT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(GPS_ENDPOINT);


export const gpsStateConfig: SignalStoreConfig<QueryState<IMapPuntiCoordinate>> = {
    initState: {
      list: [],
      // sort: {
      //   field: 'dataPrelievo',
      //   direction: 'asc'
      // }
    }
  }


export const PUNTI_CAMPIONAMENTO_COLUMNS_DASHBOARD: ITableColumn[] = [
  {
    name: 'uuid',
    label: 'Codice UUID',
    field: 'uuid',
    primaryKey: true
  },
  {
    name: 'regione',
    label: 'Regione',
    field: 'regione',
    cell: (row: IPuntoCampionamento) => row.regione?.denominazioneRegione,
  },
  {
    name: 'istatRegione',
    label: 'ISTAT Regione',
    field: 'istatRegione',
  },
  {
    name: 'istatComune.denominazioneRegione',
    label: 'Regione',
    field: 'nomeRegione',
      cell: (row: IPuntoCampionamento) => row.nomeRegione,
  },
  {
    name: 'istatComune.denominazione',
    label: 'Comune',
    field: 'comune',
    cell: (row: IPuntoCampionamento) => row.nomeComune,
  },
  {
    name: 'istatComune',
    label: 'ISTAT Comune',
    field: 'istatComune',
  },
  {
    name: 'nomeComune',
    label: 'Comune',
    field: 'nomeComune',
  },
  {
    name: 'tipoPuntoCampionamento',
    label: 'Tipo',
    field: 'tipoPuntoCampionamento',
   // cell: (row: IPuntoCampionamento) => row.puntoCampionamentoTipologia?.descrizione,
  },
  {
    name: 'idPuntoCampionamento',
    label: 'Identificativo',
    field: 'idPuntoCampionamento',
  },
  {
    name: 'idAreraAto',
    label: 'Id. ARERA ATO',
    field: 'idAreraAto',
   // cell: (row: IPuntoCampionamento) => row.areraAto?.ato,
  },
  {
    name: 'idAreraGestore',
    label: 'Id. ARERA Gestore',
    field: 'idAreraGestore',
   // cell: (row: IPuntoCampionamento) => row.areraGestore?.denominazione,
  },
  {
    name: 'codiceAcquedotto',
    label: 'Acquedotto',
    field: 'codiceAcquedotto',
    //cell: (row: IPuntoCampionamento) => row.acquedotto?.descrizione,
  },
  // {
  //   name: 'progressivoLineAcquedottistica',
  //   label: 'Progressivo Acquedotto',
  //   field: 'progressivoLineAcquedottistica'
  // },
  {
    name: 'previsioneAbitantiServiti',
    label: 'Abitanti',
    field: 'previsioneAbitantiServiti'
  },
  {
    name: 'previsionePortata',
    label: 'Portata',
    field: 'previsionePortata'
  },
  {
    name: 'descrizionePunto',
    label: 'Descrizione',
    field: 'descrizionePunto'
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note'
  },
  {
    name: 'wsz',
    label: 'Water Supply Zone',
    field: 'wsz',
   // cell: (row: IPuntoCampionamento) => row.wsz?.descrizione,
  },
  {
    name: 'numeroCampionamentoAnnuoInternoPrevisto',
    label: 'Campionamenti interni annui',
    field: 'numeroCampionamentoAnnuoInternoPrevisto',
  },
  {
    name: 'numeroCampionamentoAnnuoEsterniPrevisto',
    label: 'Campionamenti esterni annui',
    field: 'numeroCampionamentoAnnuoEsterniPrevisto',
  },
];


export const PUNTICAMPIONAMENTO_VISIBLECOLUMNS_DASHOBARD = [
  'uuid',
  'istatComune.denominazioneRegione',
  'istatComune.denominazione',
];